import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Environement
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExternalService {
  extApi = environment.extApiUrl;
  
  constructor(public httpClient: HttpClient) {
  }

  getStops() {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<[]>(this.extApi + '/index/stops/', options);
  }

  getStopInfo(stopId: string) {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<{}>(this.extApi + '/index/stops/' + stopId, options);
  }

  getStopSchedule(stopId: string) {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<{}>(this.extApi + '/index/stops/' + stopId + '/stoptimes', options);
  }

  getStopScheduleDay(stopId: string, day:string) {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<{}>(this.extApi + '/index/stops/' + stopId + '/stoptimes/' + day, options);
  }

  getStopRoutes(stopId: string) {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<{}>(this.extApi + '/index/stops/' + stopId + '/routes', options);
  }

  getRoutes() {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<[]>(this.extApi + '/index/routes', options);
  }

  getRouteDetail(routeId: string) {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<{}>(this.extApi + '/index/routes/' + routeId, options);
  }

  getMunicipalities() {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<[]>(this.extApi + '/index/municipalities', options);
  }

  getStopsByMunicipality(municipality: string) {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<[]>(this.extApi + '/index/municipalities/stops/' + municipality, options);
  }

  getRoutesByMunicipality(municipality: string) {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<[]>(this.extApi + '/index/municipalities/routes/' + municipality, options);
  }

  getFeedInfo() {
    const options: { headers: { [key: string]: string } } = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.httpClient.get<[]>(this.extApi + '/index/feed_info', options);
  }
}
